import React from "react";
import { toast } from "sonner";
import { Move, RotateCw, Trash2 } from "lucide-react";
import { C, FONT_HEAD, FONT_BODY } from "./theme";
import { VariantPicker } from "./Catalog";

// Inspector popover bangunan terpilih — info, ganti variasi, edit huruf timbul, pindah/putar/hapus
export function Inspector({ selInfo, sel, state, commit, canvasRef, signDraft, setSignDraft, onMove, onRotate, onDelete }) {
  return (
        <div data-testid="inspector-popover" style={{
          position: "absolute", left: Math.min(Math.max(selInfo.x + 12, 12), (canvasRef.current?.clientWidth || 800) - 240),
          top: Math.min(Math.max(selInfo.y - 20, 12), (canvasRef.current?.clientHeight || 600) - 170),
          width: 228, background: "#fff", borderRadius: 18, boxShadow: "0 14px 40px rgba(20,20,20,0.18)", padding: 15, zIndex: 20
        }}>
          <p data-testid="inspector-title" style={{ margin: 0, fontFamily: FONT_HEAD, fontSize: 16, fontWeight: 800, color: C.ink }}>{selInfo.def?.name || selInfo.b.bid}</p>
          <p style={{ margin: "3px 0 12px", fontSize: 11, color: C.sub }}>{selInfo.def?.w || 1}x{selInfo.def?.h || 1} • {selInfo.def?.floors || 0} lantai • posisi {selInfo.b.x},{selInfo.b.y}</p>
          {(selInfo.def?.variants || []).length > 0 && (
            <>
              <p style={{ margin: "0 0 2px", fontSize: 10, fontWeight: 700, letterSpacing: 1.5, color: C.t3, textTransform: "uppercase", fontFamily: FONT_BODY }}>Ganti Variasi</p>
              <VariantPicker def={selInfo.def} value={selInfo.b.vid || ""} size={56}
                onChange={val => {
                  commit({
                    ...state,
                    buildings: state.buildings.map((bb, i) => {
                      if (i !== sel) return bb;
                      const nb = { ...bb };
                      if (val) nb.vid = val; else delete nb.vid;
                      return nb;
                    })
                  });
                  toast.success("Variasi diganti");
                }} />
              <div style={{ height: 10 }} />
            </>
          )}
          {/* Edit huruf timbul (signboard) */}
          <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 10, marginBottom: 12 }}>
            <button data-testid="sign-edit-toggle"
              onClick={() => {
                if (signDraft && signDraft.for === sel) { setSignDraft(null); return; }
                const se = selInfo.b.signEdit || {};
                setSignDraft({ for: sel, text: se.text ?? (selInfo.def?.name || selInfo.b.bid), fg: se.fg ?? "#FF3B30", glow: se.glow ?? "#FFD700", fs: se.fs ?? 0.13 });
              }}
              style={{ width: "100%", padding: "8px 0", background: C.hoverBg, border: `1.5px solid ${C.line}`, borderRadius: 99, color: C.ink, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: FONT_BODY }}>
              {signDraft && signDraft.for === sel ? "Tutup Edit Nama" : "Edit Nama Bangunan"}
            </button>
            {signDraft && signDraft.for === sel && (
              <div data-testid="sign-edit-panel" style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
                <label style={{ fontSize: 11, color: C.sub, fontFamily: FONT_BODY }}>Teks nama
                  <input data-testid="sign-text" value={signDraft.text} maxLength={24}
                    onChange={e => setSignDraft({ ...signDraft, text: e.target.value.toUpperCase() })}
                    style={{ width: "100%", marginTop: 3, padding: "7px 10px", border: `1.5px solid ${C.line}`, borderRadius: 10, fontSize: 13, fontWeight: 700, fontFamily: FONT_BODY, boxSizing: "border-box" }} />
                </label>
                <label style={{ fontSize: 11, color: C.sub, fontFamily: FONT_BODY }}>Ukuran huruf: {Math.round(signDraft.fs * 100)}%
                  <input data-testid="sign-size" type="range" min="0.06" max="0.30" step="0.01" value={signDraft.fs}
                    onChange={e => setSignDraft({ ...signDraft, fs: parseFloat(e.target.value) })}
                    style={{ width: "100%", marginTop: 3 }} />
                </label>
                <div style={{ display: "flex", gap: 8 }}>
                  <label style={{ flex: 1, fontSize: 11, color: C.sub, fontFamily: FONT_BODY }}>Warna huruf
                    <input data-testid="sign-fg" type="color" value={signDraft.fg}
                      onChange={e => setSignDraft({ ...signDraft, fg: e.target.value })}
                      style={{ width: "100%", height: 34, marginTop: 3, border: `1.5px solid ${C.line}`, borderRadius: 8, padding: 2, background: "#fff", cursor: "pointer" }} />
                  </label>
                  <label style={{ flex: 1, fontSize: 11, color: C.sub, fontFamily: FONT_BODY }}>Glow malam
                    <input data-testid="sign-glow" type="color" value={signDraft.glow}
                      onChange={e => setSignDraft({ ...signDraft, glow: e.target.value })}
                      style={{ width: "100%", height: 34, marginTop: 3, border: `1.5px solid ${C.line}`, borderRadius: 8, padding: 2, background: "#fff", cursor: "pointer" }} />
                  </label>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button data-testid="sign-save"
                    onClick={() => {
                      commit({
                        ...state,
                        buildings: state.buildings.map((bb, i) => i !== sel ? bb : { ...bb, signEdit: { text: signDraft.text, fg: signDraft.fg, glow: signDraft.glow, fs: signDraft.fs } })
                      });
                      toast.success("Nama bangunan disimpan");
                    }}
                    style={{ flex: 1, padding: "8px 0", background: C.blue, border: 0, borderRadius: 99, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: FONT_BODY }}>
                    Simpan Nama
                  </button>
                  <button data-testid="sign-reset"
                    onClick={() => {
                      commit({
                        ...state,
                        buildings: state.buildings.map((bb, i) => {
                          if (i !== sel) return bb;
                          const nb = { ...bb }; delete nb.signEdit; return nb;
                        })
                      });
                      setSignDraft(null);
                      toast.success("Nama dikembalikan ke bawaan");
                    }}
                    style={{ flex: 1, padding: "8px 0", background: "#fff", border: `1.5px solid ${C.line}`, borderRadius: 99, color: C.ink, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: FONT_BODY }}>
                    Reset
                  </button>
                </div>
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button data-testid="inspector-move-btn" onClick={onMove}
              style={{ flex: 1, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "9px 0", background: C.blue, border: 0, borderRadius: 99, color: "#fff", fontSize: 12, fontWeight: 700, transition: "opacity 0.15s", fontFamily: FONT_BODY }}
              onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
              onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
              <Move size={13} /> Pindah
            </button>
            <button data-testid="inspector-rotate-btn" onClick={onRotate}
              style={{ flex: 1, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "9px 0", background: C.hoverBg, border: `1.5px solid ${C.line}`, borderRadius: 99, color: C.ink, fontSize: 12, fontWeight: 700, transition: "border-color 0.15s", fontFamily: FONT_BODY }}
              onMouseEnter={e => e.currentTarget.style.borderColor = C.sub}
              onMouseLeave={e => e.currentTarget.style.borderColor = C.line}>
              <RotateCw size={13} /> Putar
            </button>
            <button data-testid="inspector-delete-btn" onClick={onDelete}
              style={{ flex: 1, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "9px 0", background: "#fff", border: `1.5px solid ${C.danger}`, borderRadius: 99, color: C.danger, fontSize: 12, fontWeight: 700, transition: "background-color 0.15s", fontFamily: FONT_BODY }}
              onMouseEnter={e => e.currentTarget.style.background = "#fef2f2"}
              onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
              <Trash2 size={13} /> Hapus
            </button>
          </div>
        </div>
  );
}
